"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccurxErrorMessage = exports.isNetworkIssue = exports.getCookie = void 0;
exports.isNullWhiteSpaceOrUndefined = isNullWhiteSpaceOrUndefined;
function isNullWhiteSpaceOrUndefined(testingString) {
    return (testingString === null ||
        testingString === undefined ||
        testingString === "");
}
/**
 * Extract the value of a cookie
 * ie: Given document.cookie = apple=VAL1; banana=VAL2; pear=VAL3
 * getCookie("banana") will return VAL2
 */
const getCookie = (name) => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    if (match)
        return match[2];
    return "";
};
exports.getCookie = getCookie;
/**
 * We want to regroup all TypeError that are expected network issue.
 * Those errors will be tracked with lower severity as we are only interested by quantity deviation for a baseline
 * To replicate this type of error, block api call in devtool
 * NB: All of the listed error are the same error, just different error message depending on the browser
 * https://stackoverflow.com/questions/55738408/javascript-typeerror-cancelled-error-when-calling-fetch-on-ios
 * @param error
 * @returns boolean
 */
const isNetworkIssue = (error) => {
    return (error instanceof Error &&
        error.name === "TypeError" &&
        [
            "Failed to fetch",
            "Load failed",
            "cancelled",
            "NetworkError when attempting to fetch resource.",
        ].includes(error.message));
};
exports.isNetworkIssue = isNetworkIssue;
/**
 * Trying to extract error message from an api Response
 * @param response api response
 * @returns error message that api responded
 */
const getAccurxErrorMessage = (response) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const jsonMessage = yield response.json();
        if (jsonMessage.message)
            return jsonMessage.message.replace("\n", " ");
        if (typeof (jsonMessage) === "string")
            return jsonMessage.replace("\n", " ");
        return null;
    }
    catch (_a) {
        try {
            const responseText = yield response.text();
            return responseText.replace("\n", " ");
        }
        catch (_b) {
            return null;
        }
    }
});
exports.getAccurxErrorMessage = getAccurxErrorMessage;
//# sourceMappingURL=Helpers.js.map